import { CLIENT_ID_HEADER } from '@payaca/shared-isomorphic/constants/clientId';

export const apiFetch = (path: string, requestInit?: RequestInit) => {
  const token = localStorage.getItem('payacav1'); // TOKEN_KEY

  return fetch(`${import.meta.env.VITE_API_HOST}${path}`, {
    ...requestInit,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      [CLIENT_ID_HEADER]: 'webapp-provider',
      // oxlint-disable-next-line typescript-eslint(no-misused-spread) -- FIXME: pre-existing error: Using the spread operator on an array in an object will result in a list of indices.
      ...requestInit?.headers,
    },
  });
};
